import { ContractStatusEnum, Loading, Session, useEvent } from '@mindly/ui-components';
import React, { forwardRef, useImperativeHandle, useMemo, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { fetchLastContractBySpecialistId } from 'src/api/contracts';
import useToast from 'src/context/ToastContext/ToastContext';
import { PrivateRoutes } from 'src/routes/navigation';
import { useVideoCall } from 'src/shared/hooks/useVideoCall';

type SessionStartProps = {};

export type SessionStartRef = {
  openSession: (session: Session) => void;
};

const SessionStart = forwardRef<SessionStartRef, SessionStartProps>((_, ref) => {
  const history = useHistory();
  const { showToast } = useToast();
  const [isContractLoading, setIsContractLoading] = useState(false);
  const { handleModalVideoClick, isLoading: isVideoCallLoading } = useVideoCall();

  useImperativeHandle(ref, () => ({
    openSession: handleVideoCall,
  }));

  const handleVideoCall = useEvent(async (session: Session) => {
    try {
      setIsContractLoading(true);
      const contract = await fetchLastContractBySpecialistId(session?.psychologist_id);
      if (session?.therapist?.mindly_contract_status === ContractStatusEnum.active && !contract) {
        history.push(PrivateRoutes.UPDATE_CONTRACT_WARNING, {
          selectedSession: session,
        });
        return;
      }
    } catch (error) {
      showToast({
        error,
      });
    } finally {
      setIsContractLoading(false);
    }

    handleModalVideoClick(session);
  });

  const isLoading = useMemo(() => isContractLoading || isVideoCallLoading, [isContractLoading, isVideoCallLoading]);

  return (
    <>
      <Loading isOpen={isLoading} />
    </>
  );
});

export default SessionStart;
